<template>
    <div class="scheme-view flex-fill flex-h">
        <OverviewSidebar
            :devices="shownDevices"
            :is-loading="isLoading"
            @device-click="focusOnDevice"
        />

        <Scheme
            v-if="scene"
            :scene="scene"
            :devices="shownDevices"
            :focused-device="focusedDevice"
            @change:focused-device="focusOnDevice"
        />
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import {Inject} from 'vue-property-decorator'
import Api from '@/services/Api'
import {Scene} from '@/types/Scene'
import Scheme from '@/components/scheme/Scheme.vue'
import {Device} from '@/models/Device'
import OverviewSidebar from '@/views/overview/OverviewSidebar.vue'

@Component({
    components: {OverviewSidebar, Scheme},
})
export default class OverviewView extends Vue
{
    @Inject('api') private api!: Api

    devices: Device[] = []
    scene: Scene | null = null

    updateIntervalId: ReturnType<typeof setInterval> | null = null
    isLoading = false

    focusedDevice: Device | null = null

    async fetchDevices() {
        if (this.isLoading) {
            return
        }

        this.isLoading = true
        this.devices = await this.api.listDevices({
            expand: ['typeLabel', 'lastPowerPacket', 'lastDetectorPacket', 'stateLabel', 'group', 'isEmitting'],
        })
        this.isLoading = false
    }

    async fetchScene() {
        this.scene = await this.api.getScene()
    }

    mounted() {
        this.fetchScene()
        this.fetchDevices()
        this.updateIntervalId = setInterval(() => {
            this.fetchDevices()
        }, 2000)
    }

    destroyed() {
        if (this.updateIntervalId) {
            clearInterval(this.updateIntervalId)
            this.updateIntervalId = null
        }
    }

    focusOnDevice(device: Device | null) {
        this.focusedDevice = device
    }

    get isHiddenShown() {
        return this.$store.state.settings?.schemeView?.isHiddenShown ?? false
    }

    get shownDevices(): Device[] {
        const shownDevices = this.isHiddenShown ? this.devices : this.devices.filter(d => !d.isHidden)
        return [...shownDevices].sort((a: Device, b: Device) => a.name < b.name ? -1 : (a.name > b.name ? 1 : 0))
    }
}
</script>
